export function initHotjar(hotjarId, hotjarVersion, hotjarDebug = false, logCallback) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (window.hj && document.getElementById('hotjar-script')) return true;

  window.hj = window.hj || function hotjarQueue() {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
  window._hjSettings = {
    hjid: hotjarId,
    hjsv: hotjarVersion,
    hjdebug: Boolean(hotjarDebug),
  };

  const script = document.createElement('script');
  script.id = 'hotjar-script';
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${hotjarId}.js?sv=${hotjarVersion}`;
  document.head.appendChild(script);
  if (typeof logCallback === 'function') logCallback('Hotjar ready: true');
  return true;
}

export function initHotjarAfterPageLoad(hotjarId, hotjarVersion, hotjarDebug = false, logCallback) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  // Automated browsers (Playwright, Selenium) are not visitors. Recording them
  // pollutes the production Hotjar site that Development also uses, and the
  // hidden about:blank iframe Hotjar adds re-attaches during reloads, which
  // trips Firefox Playwright's internal frame assert (production readiness
  // 36068943829, microsoft/playwright#23638).
  if (window.navigator?.webdriver === true) return false;
  const start = () => initHotjar(hotjarId, hotjarVersion, hotjarDebug, logCallback);
  if (document.readyState === 'complete') return start();
  window.addEventListener('load', start, { once: true });
  return false;
}
